import { post, uploadFile } from './api';

export const getSearchList = function(params) {
    return post('/search/goods', params);
};

export const getDetailHeader = function(params) {
    return post('/index/queryGoodsInfo', params);
};

export const queryByCasCode = function(params) {
    return post('/index/queryByCasCode', params);
};

export const queryListByCasCode = function(params) {
    return post('/index/queryListByCasCode', params);
};

// 2022.6 耗材新换接口

// 耗材头部
export const querymaterialshead = function(params) {
    return post('/search/materials/head', params);
};

// 耗材商品搜索
export const querymaterials = function(params) {
    return post('/search/materials', params);
};

// 耗材商品搜索v2
export const querymaterialsv2 = function(params) {
    return post('/search/v2/materials', params);
};

// 搜索日志保存
export const searchLogsave = function(params) {
    return post('/searchLog/save', params);
};

export const upFile = function(params) {
    return uploadFile('/placeOrder/upload', params);
};

// 获取区域禁用列表
export const queryCasProhibitShipmentSampleList = function(params) {
    return post('/placeOrder/queryCasProhibitShipmentSampleList', params);
};
